module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dt-ny-600.3bffda829e60e86d.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/dt-ny-600.3bffda829e60e86d.png",width: 600,height: 450}],
        src: "https://static.sniffspot.com/packs/img/dt-ny-600.3bffda829e60e86d.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dt-ny-600.3bffda829e60e86d.png"},
        
        width: 600,
        height: 450
      }